<template>
  <div id="ISVReg">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设置</el-breadcrumb-item>
          <el-breadcrumb-item>支付宝设置</el-breadcrumb-item>
          <el-breadcrumb-item>ISV注册管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px"
             class="pageSearch">
      <el-row>
        <el-col :span="22">
          <el-form-item>
            <el-input placeholder="请输入商户名称"
                      v-model="pageSearch.searchKeyWord"
                      class="search">
              <!-- <i slot="prefix"
               class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="2"
                class="searchRowAdd">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-edit"
                     v-if="is_edit"
                     @click="handleAdd">新增商户
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号"
                           align="right">
          </el-table-column>
          <el-table-column prop="fMerName"
                           label="商户名称">
          </el-table-column>
          <el-table-column label="商户客服电话"
                           prop="fMerSvrPhone">
          </el-table-column>
          <el-table-column prop="fAccNo"
                           label="支付宝账号">
          </el-table-column>
          <el-table-column prop="fUrl"
                           label="支付宝缴费地址">
          </el-table-column>
          <el-table-column label="商户LOGO"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <img v-if="(scope.row.fLogoUrl||'').length>0"
                   :src="scope.row.fLogoUrl"
                   style="width:27px;height:27px;vertical-align: middle;">
            </template>
          </el-table-column>
          <el-table-column prop="fPid"
                           label="支付宝PID">
          </el-table-column>
          <el-table-column prop="fAppID"
                           label="支付宝APPID">
          </el-table-column>
          <el-table-column prop="fRemark"
                           label="备注">
          </el-table-column>

          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="160">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         v-if="is_edit"
                         @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="50%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="isv"
               :rules="rules"
               ref="ruleForm"
               label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户简称::"
                          prop="fMerName">
              <el-input v-model="isv.fMerName"
                        :disabled="formDisabled"
                        placeholder="请填写商户简称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客服电话::"
                          prop="fMerSvrPhone">
              <el-input v-model="isv.fMerSvrPhone"
                        :disabled="formDisabled"
                        placeholder="请填写商户客服电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="ISV类型::"
                          prop="fIsvType">
            <el-radio-group  :disabled="formDisabled" v-model="isv.fIsvType">
              <el-radio label="0">H5</el-radio>
              <el-radio label="1">小程序</el-radio>
              <el-radio label="2">协议状态变更通知</el-radio>
           </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="调用地址url::"
                          prop="fUrl">
              <el-input v-model="isv.fUrl"
                        :disabled="formDisabled"
                        placeholder="小程序填写格式：appid|页面地址，其他为url地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付宝账号::"
                          prop="fAccNo">
              <el-input v-model="isv.fAccNo"
                        :disabled="formDisabled"
                        placeholder="请填写签约支付宝账号"></el-input>
            </el-form-item>
          </el-col>
     <el-col :span="12">
            <el-form-item label="支付宝APPID::"
                          prop="fAppID">
              <el-input v-model="isv.fAppID"
                        :disabled="formDisabled"
                        placeholder="请填写支付宝APPID"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付宝PID::"
                          prop="fPid">
              <el-input v-model="isv.fPid"
                        :disabled="formDisabled"
                        placeholder="请填写支付宝PID"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fkey_row">
          <el-col :span="24">
            <el-form-item label="商户私钥::"
                          prop="fPriKey">
              <el-input type="textarea"
                        v-model="isv.fPriKey"
                        :disabled="formDisabled"
                        placeholder="请填写商户宝私钥"
                        class="fkey"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fkey_row">
          <el-col :span="24">
            <el-form-item label="支付宝公钥::"
                          prop="fPubKey">
              <el-input type="textarea"
                        v-model="isv.fPubKey"
                        :disabled="formDisabled"
                        placeholder="请填写支付宝公钥"
                        class="fkey"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商户LOGO::"
                          prop="fLogoUrl"
                          style="margin-bottom:0px;">
              <el-upload class="avatar-uploader"
                         action="javascript(0)"
                         :show-file-list="false"
                         :disabled="formDisabled"
                         :before-upload="beforeAvatarUpload">
                <img v-if="(isv.fLogoUrl||'').length>0"
                     :src="isv.fLogoUrl"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label=" ">
              <el-button @click="isv.fLogoUrl=''"
                         type="danger"
                         icon="el-icon-delete"
                         style="padding:5px;"
                         :disabled="formDisabled"
                         circle></el-button>&nbsp;<span style="color:red;font-size:12px;">图片必须为png格式，尺寸27px*27px，大小不要超过60kb</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="备注::"
                          prop="fRemark">
              <el-input type="textarea"
                        v-model="isv.fRemark"
                        :disabled="formDisabled"
                        class="fRemark"
                        placeholder="请填写商户备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="!formDisabled">保存</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
      <!-- <el-row style="margin-top:-1px">
        <el-col :span="12">
          <div class="tab_foot">&nbsp;</div>
        </el-col>
        <el-col :span="12">
          <div class="dialog-footer">
            <el-button type="primary"
                       @click="submitForm('ruleForm')"
                       v-if="!formDisabled">保存</el-button>
            <el-button @click="dialogFormVisible = false">取消</el-button>
          </div>
        </el-col>
      </el-row> -->
    </el-dialog>
  </div>
</template>
<script>
import { setting as api } from '../../api/setting'
import * as user from '../../api/user'
export default {
  data () {
    var validateUrl = (rule, value, callback) => {
      if (this.isv.fis) {
        if ((this.isv.fUrl || '').length > 0) {
          var re = /^(https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\\.,@?^=%&:/~\\+#]*[\w\-\\@?^=%&/~\\+#])?$/
          if (!re.test(value)) {
            callback(new Error('请填写https格式url链接'))
          }
        }
      }
      callback()
    }
    return {
      is_edit: false,
      is_del: false,
      is_syn: false,
      formDisabled: false,
      tableHeight: 0,
      dialogFormVisible: false,
      loading: true,
      dialogTitle: '',
      pageData: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        searchKeyWord: ''
      },
      isv: {
        fIsvID: '',
        fIsvType: '',
        fMerName: '',
        fMerSvrPhone: '',
        fAccNo: '',
        fUrl: '',
        fLogoUrl: '',
        fAppID: '',
        fPid: '',
        fPriKey: '',
        fPubKey: '',
        fRemark: ''

      },
      rules: {
        fMerName: [
          { required: true, message: '请输入商户简称', trigger: 'blur' }
        ],
        fIsvType: [
          { required: true, message: '请选择ISV类型', trigger: 'blur' }
        ],
        fMerSvrPhone: [
          { required: true, message: '请输入客服电话', trigger: 'blur' },
          { max: 20, message: '长度不超过 20 个字符', trigger: 'blur' }
        ],
        fAccNo: [
          { required: true, message: '请输入签约支付宝账号', trigger: 'blur' }
        ],
        fAppID: [
          { required: true, message: '请输入支付宝APPID', trigger: 'blur' }
        ],
        fUrl: [
          { validator: validateUrl, trigger: 'blur' },
          { required: true, message: '请填写url地址', trigger: 'blur' }
        ],
        fPriKey: [
          { required: true, message: '请输入商户私钥', trigger: 'blur' }
        ],
        fPubKey: [{ required: true, message: '请输入支付宝公钥', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      api.aliPayISVPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载支付宝ISV注册信息失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    beforeAvatarUpload (file) {
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 <= 60

      if (!isPNG) {
        this.$message.error('上传LOGO图片只能是 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传LOGO图片大小不能超过 60kb!')
        return false
      }
      if (isPNG && isLt2M) {
        // 显示图片
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.isv.fLogoUrl = reader.result
        }
      }
      return false
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleInfo (index, row) {
      this.dialogTitle = '【' + row.fMerName + '】查看商户ISV信息'
      this.formDisabled = true
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogFormVisible = true
      api.aliPayISVPageInfo(row.fIsvID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.isv = data.Data || {}
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleEdit (index, row) {
      this.dialogTitle = '【' + row.fMerName + '】编辑商户ISV信息'
      this.formDisabled = false
      this.isv.fLogoUrl = ''
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogFormVisible = true
      api.aliPayISVPageInfo(row.fIsvID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.isv = data.Data || {}
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleAdd () {
      this.dialogTitle = '新增商户'
      this.isv = {
        fIsvID: '',
        fMerName: '',
        fIsvType: '1',
        fMerSvrPhone: '',
        fAccNo: '',
        fUrl: '',
        fLogoUrl: '',
        fAppID: '',
        fPid: '',
        fPriKey: '',
        fPubKey: '',
        fRemark: ''
      }
      setTimeout(() => {
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].clearValidate()
        }
      }, 50)
      this.formDisabled = false
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          api.aliPayISVEdit(this.isv).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 220
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 100000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#ISVReg .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#ISVReg .el-dialog__title {
  color: white;
}
#ISVReg .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#ISVReg .el-dialog__body {
  padding: 30px 20px 0px 20px;
}
#ISVReg .is-disabled .el-input__inner,
#ISVReg .is-disabled .el-textarea__inner {
  color: #606266;
}

#ISVReg .fRemark > .el-textarea__inner {
  height: 180px;
}
#ISVReg .fRemark_row .el-form-item__content {
  height: 180px;
}
#ISVReg .fkey > .el-textarea__inner {
  height: 60px;
}
#ISVReg .fkey_row .el-form-item__content {
  height: 60px;
}
/* 上传图片 */
#ISVReg .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  line-height: 27px;
}
#ISVReg .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
#ISVReg .avatar-uploader-icon {
  font-size: 10px;
  color: #8c939d;
  width: 27px;
  height: 27px;
  line-height: 27px;
  text-align: center;
}
#ISVReg .avatar {
  width: 27px;
  height: 27px;
  display: block;
}
</style>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/ISVReg.vue